import * as React from "react";
import { Col, Row, Image, Button } from "react-bootstrap";

interface Props {
	img: string;
	title: string;
	text: string;
	preOrder: boolean;
	orderLink: string;
	moreLink: string;
	bg: "light" | "dark"
}

export default function Product(props: Props) {
	return (
		<>
			<Row>

				<Col className="product-preview-image-col" style={{ backgroundColor: props.bg === "light" ? "#EEEEF1" : "#E9E9E9" }}>
					<Image
						className="product-preview-image"
						src={props.img}
						alt={`Image of ${props.title}`}
					/>
				</Col>
				<Row style={{paddingLeft:"1.5em"}}>
					<Col>
						<Image
							className="product-name"
							src={props.title}
						/>
					</Col>
				</Row>
				<p style={{minHeight:"6rem", paddingLeft:"1.5em"}}>
					{props.text}
				</p>
				<Row>
					<Button variant="eo-primary" style={{ marginRight: "1em", marginLeft: "1em" }} href={props.orderLink}>{props.preOrder ? "Order" : "Order"}</Button>
					<Button variant="eo-primary-outline" href={props.moreLink}>More Info</Button>
				</Row>
			</Row>
		</>
	);
}
